import { IAnchorTransformConfig } from "./interfaces/IAnchorTransformConfig";

export const globalAnchorTransformConfig: IAnchorTransformConfig = {
    preprocessHref: (): string => {
        throw new Error("Href rule not configured");
    }
};
